import { Box, Button, InputAdornment, TextField, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setPassword } from "../../base/conference/actions.any";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../../notifications";
import { parseURIString } from "../../base/util";
import apiManagerRoom from "../../api/apiManagerRoom";
import ClickableIcon from "../../base/ui/components/web/ClickableIcon";
import { sendCommand } from "../../mod-command/slice";
import { COMMANDS } from "../../mod-command/constants";
import { toastError } from "../../notifications/components/web/Toastify";
const IconRemove = () => {
    return (React.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5 3.82107L8.53553 0.285534L9.71405 1.46405L6.17851 4.99958L9.71405 8.53511L8.53553 9.71362L5 6.17809L1.46447 9.71362L0.285955 8.53511L3.82149 4.99958L0.285955 1.46405L1.46447 0.285534L5 3.82107Z", fill: "#8F9294" })));
};
const PasswordRoom = () => {
    const { conference, locked, password } = useSelector((state) => state["features/base/conference"]);
    const state = useSelector((state) => state);
    const { t } = useTranslation();
    const [passwordEditEnabled, setPasswordEditEnabled] = useState(false);
    const [enterPassword, setEnterPassword] = useState(password);
    const [validate, setValidate] = useState(false);
    const dispatch = useDispatch();
    let strongPassword = /^[^\s\u00C0-\u024F]{8,32}$/;
    const onPasswordSubmit = (enteredPassword) => {
        dispatch(setPassword(conference, conference?.lock, enteredPassword));
        dispatch(sendCommand(COMMANDS.SET_PASSWORD.COMMAND, enteredPassword, true));
    };
    const onPasswordSave = async () => {
        if (strongPassword.test(enterPassword ?? "")) {
            await apiManagerRoom.updatePassword({
                room_id: window.location.pathname.split("/")[1],
                password: enterPassword
            })
                .then((json) => {
                onPasswordSubmit(enterPassword);
                setValidate(false);
                setPasswordEditEnabled(false);
            })
                .catch((error) => {
                toastError({
                    title: t("dialog.error"),
                    content: t("dialog.error")
                });
            });
        }
        else {
            setValidate(true);
        }
    };
    const onCopyPass = () => {
        navigator.clipboard.writeText(password || "");
        dispatch(showNotification({
            descriptionKey: t("dialog.copyPassword.content"),
            titleKey: t("dialog.copyPassword.title"),
        }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
    };
    const renderButton = () => {
        if (passwordEditEnabled) {
            return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'end' } },
                React.createElement(Button, { sx: { fontSize: '14px', marginLeft: '0.25rem', padding: '5px !important', minWidth: 'fit-content !important', height: '32px' }, variant: "contained", onClick: onPasswordSave }, t('menuController.save')),
                React.createElement(Button, { sx: { fontSize: '14px', padding: '5px !important', minWidth: 'fit-content !important', height: '32px', marginLeft: '6px !important' }, variant: "outlined", onClick: () => {
                        setValidate(false);
                        setPasswordEditEnabled(!passwordEditEnabled);
                        setEnterPassword("");
                    } }, t('dialog.Cancel'))));
        }
        if (locked) {
            return (React.createElement(Button, { sx: { fontSize: '14px', height: '32px', textWrap: 'nowrap', minWidth: 'fit-content' }, variant: "outlined", onClick: () => setPasswordEditEnabled(!passwordEditEnabled) }, t('dialog.changePassword')));
        }
        else {
            return (React.createElement(Button, { sx: { fontSize: '14px', height: '32px' }, variant: "outlined", onClick: () => setPasswordEditEnabled(!passwordEditEnabled) }, t('menuController.addPass')));
        }
    };
    useEffect(() => {
        let location = parseURIString(window.location.href);
        const getDetailRoom = async () => {
            await apiManagerRoom.getDetailRoom(location?.room)
                .then((json) => {
                setEnterPassword(json?.data[0]?.password != 0 ? json?.data[0]?.password : '');
            });
        };
        getDetailRoom();
    }, []);
    useEffect(() => {
        if (password && passwordEditEnabled) {
            setEnterPassword(password);
        }
    }, [passwordEditEnabled]);
    useEffect(() => {
        if (validate) {
            let objDiv = document.getElementById("menu-controller-room");
            if (objDiv) {
                objDiv.scrollTop = objDiv.scrollHeight;
            }
        }
    }, [validate]);
    useEffect(() => {
        if (validate) {
            if (strongPassword.test(enterPassword ?? "")) {
                setValidate(false);
            }
        }
    }, [enterPassword]);
    return (React.createElement(Box, { sx: { width: '100%' } },
        React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', overflow: 'hidden' } },
                React.createElement("span", { style: { whiteSpace: 'nowrap' } },
                    t('menuController.pass'),
                    (password ?? '').length > 0 && ":"),
                (!passwordEditEnabled && password) && React.createElement(Tooltip, { title: password },
                    React.createElement("span", { onClick: onCopyPass, style: { fontWeight: '600', cursor: 'pointer', marginLeft: '0.25rem', marginRight: '0.25rem', overflow: 'hidden', textOverflow: 'ellipsis' } }, password)),
                passwordEditEnabled &&
                    React.createElement(TextField, { sx: {
                            fontSize: '14px',
                            padding: '0px',
                            marginLeft: '0.5rem',
                            width: '120px',
                            '& .MuiInputBase-root': {
                                height: '32px',
                                paddingRight: '0px !important',
                                '& input': {
                                    padding: '8px 0 8px 16px !important',
                                    fontSize: '14px !important'
                                },
                                "&.Mui-focused": {
                                    borderColor: 'red',
                                },
                            }
                        }, autoFocus: true, value: enterPassword ?? "", onChange: e => setEnterPassword(e.target.value), error: validate, InputProps: {
                            endAdornment: (React.createElement(InputAdornment, { position: "end" }, (enterPassword ?? "")?.length > 0 ? (React.createElement("div", { style: { padding: '4px' } },
                                React.createElement(ClickableIcon, { accessibilityLabel: "close", icon: IconRemove, onClick: () => {
                                        setEnterPassword('');
                                    } }))) : (React.createElement(React.Fragment, null)))),
                        } })),
            renderButton()),
        React.createElement(Box, { sx: { color: 'red', fontSize: '14px', lineHeight: '16px', marginTop: '0.5rem' } }, validate && t('menuController.validatePass'))));
};
export default PasswordRoom;
